import { Tag } from "../types/Tag";
import { useGetTagsQuery } from "../../features/api/tagSlice";
import TagsList from "../components/tags/TagsList";
import TagsOverview from "../components/tags/TagsOverview";

import React, { useState, useEffect } from "react";
import { Box, Toolbar, Container, Grid } from "@mui/material";

const Tags: React.FC = () => {
    const [query, setQuery] = useState("");
    const { data: tags, isSuccess, isLoading } = useGetTagsQuery();
    const [filteredTags, setFilteredTags] = useState<Tag[]>([]);

    function filterTags(tags: Tag[]) {
        // filter tags by query
        return tags.filter((tag: Tag) => tag.label.toLowerCase().includes(query.toLowerCase()));
    }

    useEffect(() => {
        if (isSuccess) {
            setFilteredTags(filterTags(tags));
        }
    }, [query, tags]);

    if (isLoading) {
        return <div>Loading...</div>;
    } else if (!isSuccess) {
        return <div>Error</div>;
    }

    return (
        <Box
            component="main"
            sx={{
                backgroundColor: (theme) =>
                    theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900],
                flexGrow: 1,
                height: "100vh",
                overflow: "auto",
            }}
        >
            <Toolbar />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Grid container spacing={3}>
                    {/* Overview */}
                    <Grid item xs={12}>
                        <TagsOverview tagsCount={tags.length} query={query} setQuery={setQuery} />
                    </Grid>

                    {/* Tags List */}
                    <Grid item xs={12}>
                        <TagsList tags={filteredTags} />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Tags;
